const state = {
    checked: false,
    hasUpdate: false,
    currentVersion: '',
    remoteVersion: '',
    downloadUrl: '',
    updateContent: '',
    downloading: false,
    downloadPercent: 0,
    downloadStatus: '',
    downloadError: '',
    rawData: null
}

const mutations = {
    SET_UPDATE_INFO(state, info = {}) {
        state.checked = true
        state.hasUpdate = !!info.hasUpdate
        state.currentVersion = info.currentVersion || ''
        state.remoteVersion = info.remoteVersion || ''
        state.downloadUrl = info.downloadUrl || ''
        state.updateContent = info.updateContent || ''
        state.rawData = info.rawData || null
    },
    SET_DOWNLOAD_PROGRESS(state, progress = {}) {
        state.downloadStatus = progress.status || ''
        state.downloadError = progress.message || ''

        if (progress.status === 'starting') {
            state.downloading = true
            state.downloadPercent = 0
            return
        }

        if (progress.status === 'downloading') {
            state.downloading = true
            state.downloadPercent = progress.percent || 0
            return
        }

        if (progress.status === 'finished' || progress.status === 'opened') {
            state.downloading = false
            state.downloadPercent = 100
            return
        }

        if (progress.status === 'error') {
            state.downloading = false
        }
    },
    CLEAR_UPDATE_INFO(state) {
        state.checked = false
        state.hasUpdate = false
        state.currentVersion = ''
        state.remoteVersion = ''
        state.downloadUrl = ''
        state.updateContent = ''
        state.downloading = false
        state.downloadPercent = 0
        state.downloadStatus = ''
        state.downloadError = ''
        state.rawData = null
    }
}

const actions = {
    setUpdateInfo({ commit }, info) {
        commit('SET_UPDATE_INFO', info)
    },
    setDownloadProgress({ commit }, progress) {
        commit('SET_DOWNLOAD_PROGRESS', progress)
    },
    clearUpdateInfo({ commit }) {
        commit('CLEAR_UPDATE_INFO')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
